import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ListChildsPage from "./list";
import EditChildPage from "./edit";
import PreviewChildPage from "./child-preview";
import AddChildPage from "./add-child-page";

const ChildsRoutingPages = ({ match }) => (
	<Suspense fallback={<div className="loading" />}>
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />

			<Route path={`${match.url}/list`} render={(props) => <ListChildsPage {...props} />} />

			<Route path={`${match.url}/add-new`} render={(props) => <AddChildPage {...props} />} />

			<Route path={`${match.url}/edit/:childId`} render={(props) => <EditChildPage {...props} />} />

			<Route path={`${match.url}/preview/:childId`} render={(props) => <PreviewChildPage {...props} />} />

			<Redirect from={`${match.url}/`} to={`${match.url}/list`} />
			<Redirect to="/error" />
		</Switch>
	</Suspense>
);
export default ChildsRoutingPages;
